import { useAsyncData } from '#imports'

import type { AlgoliaProduct } from '@backmarket/http-api/src/api-specs-search-reco/search/searchAlgolia'
import { toPublicPath } from '@backmarket/nuxt-layer-base/utils/toPublicPath'

const GENERATED_IMAGES_BASE_URL =
  'https://s1.statics.backmarket.com/outlet/images-generated'
const NUMBER_OF_IMAGES = 3

export function useProductImages() {
  const { data } = useAsyncData(
    'outlet-uuid-directory',
    () =>
      $fetch<Record<string, string>>(
        import.meta.server
          ? '/data/outlet/uuid-directory.json'
          : toPublicPath('/data/outlet/uuid-directory.json'),
      ),
    {
      default: () => ({}) as Record<string, string>,
      server: true,
      lazy: false,
    },
  )

  const getProductImages = (algoliaProduct: AlgoliaProduct): string[] => {
    const productId = algoliaProduct.id
    const directory = data.value[productId]

    if (directory) {
      return Array.from({ length: NUMBER_OF_IMAGES }, (_, i) => {
        return `${GENERATED_IMAGES_BASE_URL}/${directory}/${directory}--${i + 1}.png`
      })
    }

    return algoliaProduct.image1 ? [algoliaProduct.image1] : []
  }

  return { getProductImages }
}
